module.exports = __webpack_public_path__ + "494cd07c/img/archive-icon.0a6a9de3.svg";